import './skills.css'
import Skill from './Skill';
import { skills } from '../../apicall';

export default function Skills() {
  console.log(skills[0].title)
  return (
  <div className="skillscntr">
    {skills.map((item, i) => {
        return (
          <Skill key = {i} color = {item.color} title={item.title} cmpt={item.cmpt} desc={item.desc}/>
        )
      })}
    </div>
  )
}
